import { render } from "./QuantyEvolucionChart.vue?vue&type=template&id=4a9e0799&scoped=true"
import script from "./QuantyEvolucionChart.vue?vue&type=script&lang=js"
export * from "./QuantyEvolucionChart.vue?vue&type=script&lang=js"

import "./QuantyEvolucionChart.vue?vue&type=style&index=0&id=4a9e0799&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9e0799"]])

export default __exports__